import React, {useState,useCallback, useEffect} from 'react';
import RGL, { WidthProvider } from 'react-grid-layout';
import AddSvg from '../../../svg/admin/Add';
import '../../../../node_modules/react-grid-layout/css/styles.css';
import '../../../../node_modules/react-resizable/css/styles.css';
import DropDownMenu from '../../components/DropDownMenu';
import _ from 'lodash';
import MDEditor from '@uiw/react-md-editor';
const ReactGridLayout = WidthProvider(RGL);

const rowHeight =90
const numOfRow = 7
const convertToLayout=(data)=>{return data?.map((item,index)=>({i:`${index}`,x:0,y:index*numOfRow,w:1,h:numOfRow,data:item}))||[]}

function Component(props){
    const [layout,setlayout] = useState(convertToLayout(props.data?.questionnaires||[]));
    useEffect(()=>{
        //work around for issue of ReactGridLayout not updating width
        window.dispatchEvent(new Event('resize'));
    },[layout]);
    useEffect(()=>{
        setlayout(convertToLayout(props.data?.questionnaires||[]))
    },[props.data])
    
    const onDragStop=useCallback((layout)=>(layout_, oldItem, newItem)=>{
        const clonelayout=[...layout_]//_.cloneDeep(layout);
        const index=_.findIndex(layout,{'i':oldItem.i})
        let dragY=clonelayout[index].y
        if(layout[index].y<dragY){
            for(let i in layout){
                if(layout[i].y<=dragY&&layout[i].y>layout[index].y)
                    clonelayout[i].y=layout[i].y-1
            }
        }else if(layout[index].y>dragY){
            for(let i in layout){
                if(layout[i].y>=dragY&&layout[i].y<layout[index].y)
                    clonelayout[i].y=layout[i].y+1
            }
        }else return
        clonelayout[index].y=dragY
        setlayout(clonelayout)
        if(props.updateOrder)props.updateOrder(layout,clonelayout)
    },[layout])

    const onAddCard=()=>{if(props.onAddCard)props.onAddCard()}
    const onDelete=(item,index)=>()=>{if(props.onDelete){props.onDelete(item,index)}};
    const onEditKey=(item,index,key)=>(e)=>{if(props.onEditKey)props.onEditKey(item,index,key,e.target.value)};

    const handleSelectQuestionType=(item,index)=>(type,typeIndex)=>{
        if(props.onEditKey)props.onEditKey(item,index,'type',type);
    }
    const handleAddOption=(item,index)=>()=>{
        if(props.onEditKey)props.onEditKey(item,index,'options',[...item.data?.options||[],{text:`選擇 ${(item.data?.options?.length||0)+1}`}]);
    }
    const handleUpdateMCAnswer=(item,index,option,optionIndex)=>(e)=>{
        if(props.onEditKey)props.onEditKey(item,index,'options',[...item.data?.options.slice(0,optionIndex),{...option,text:e.target.value},...item.data?.options.slice(optionIndex+1)])
    }
    const handleRemoveMCOption=(item,index,option,optionIndex)=>()=>{
        if(props.onEditKey)props.onEditKey(item,index,'options',[...item.data?.options.slice(0,optionIndex),...item.data?.options.slice(optionIndex+1)])
    }
    const handleAddRow=(item,index)=>()=>{
        if(props.onEditKey)props.onEditKey(item,index,'rows',[...item.data?.rows||[],{text:`問題 ${(item.data?.rows?.length||0)+1}`}]);
    }
    const handleUpdateRow=(item,index,option,optionIndex)=>(e)=>{
        if(props.onEditKey)props.onEditKey(item,index,'rows',[...item.data?.rows.slice(0,optionIndex),{...option,text:e.target.value},...item.data?.rows.slice(optionIndex+1)])
    }
    const handleRemoveRow=(item,index,option,optionIndex)=>()=>{
        if(props.onEditKey)props.onEditKey(item,index,'rows',[...item.data?.rows.slice(0,optionIndex),...item.data?.rows.slice(optionIndex+1)])
    }



    return (
        <div style={{ width: '100%', boxSizing: 'border-box' }}>
            <div className='flex flex-col w-full'>
                <div className='w-full flex flex-row w-full items-center gap-[16px] justify-between py-[2px] px-[16px] text-[14px] font-[700]'>
                    <div className='w-[20px]'></div>
                    <div className='w-[16px]'>#</div>
                    <div className='flex-1'>內容</div>
                </div>
                <ReactGridLayout
                    className='layout'
                    layout={layout}
                    cols={1}
                    rowHeight={rowHeight}
                    maxRows={layout.length * numOfRow}
                    preventCollision={true}
                    allowOverlap={true}
                    isDraggable={true}
                    isResizable={false}
                    onDragStop={onDragStop(layout)}
                    draggableHandle='.drag-handle'
                    style={{ height: layout.length * ((rowHeight+10)*numOfRow)  , margin: 0, padding: 0 }}
                >
                    {layout?.map((item, index) => (
                        <div
                            key={item.i}
                            className='flex flex-row w-full items-start py-[8px] gap-[16px] justify-between px-[4px] rounded-[7px]'
                            style={{ border: '2px solid #D9D9D9',height:rowHeight }}
                        >
                            <div className='drag-handle cursor-pointer w-[20px]'>
                                <DragIcon />
                            </div>
                            <div className='w-[16px]'>{Number(index) + 1}</div>
                            <div className='flex-[1] flex flex-col gap-[8px] h-[100%]' style={{overflowY:'auto'}}>
                                {/* <div className='font-[700]'>對話</div>
                                <input
                                    className='bg-[#F0F0F0] rounded-[7px] w-full px-[12px] py-[4px]'
                                    style={{}}
                                    value={props.data?.questionnaires[index]?.dialog || ''}
                                    onChange={onEditKey(item, index, 'dialog')}
                                /> */}
                                {/* <MDEditor data-color-mode="light"
                                        className='bg-white'
                                        value={props.data?.questionnaires?.[index]?.name||''}
                                        onChange={(v)=>{onEditKey(item,index,'name')({target:{value:v}})}}
                                /> */}
                                <div className='flex flex-row w-full gap-[16px] flex-wrap'>
                                   
                                    <div className='flex flex-col'>
                                        <div className='font-[700]'>問題類型</div>
                                        <div className='flex flex-row'>
                                            <DropDownMenu
                                                select={handleSelectQuestionType(item, index)}
                                                value={props.data?.questionnaires[index]?.type || '--- 無 ---'}
                                                minWidth={250}
                                                options={[ '選擇題', '短句作答題','表格問題']}
                                            />
                                        </div>
                                    </div>
                                    {['選擇題','選擇題 + 短句作答題'].includes(props.data?.questionnaires[index]?.type)&&
                                        <div className='flex flex-col'>
                                            <div className='font-[700]'>選擇題類型</div>
                                            <div className='flex flex-row'>
                                                <DropDownMenu
                                                    select={(type)=>{if(props.onEditKey)props.onEditKey(item,index,'multipleChoiceType',type)}}
                                                    value={props.data?.questionnaires[index]?.multipleChoiceType || '單項選擇題'}
                                                    minWidth={250}
                                                    options={['單項選擇題', '多項選擇題']}
                                                />
                                            </div>
                                        </div>
                                    }
                                </div>

                                {/*multiple choice question*/}
                                {['選擇題','選擇題 + 短句作答題'].includes(props.data?.questionnaires[index]?.type) && (
                                    <div className='w-full flex flex-col p-[16px] bg-[#F8F8F8] gap-[8px] rounded-[7px]'>
                                        <div className='font-[700]'>選擇題問題</div>
                              
                                        <MDEditor data-color-mode="light"
                                            style={{minHeight:100}}
                                            className='bg-white'
                                            value={props.data?.questionnaires?.[index]?.question||''}
                                            onChange={(v)=>{onEditKey(item,index,'question')({target:{value:v}})}}
                                        />
                                        <div className='font-[700]'>選擇題答案</div>
                                        {item?.data?.options?.map((option, optionIndex) => (
                                            <div key={optionIndex} className='flex flex-row gap-[8px] items-center'>
                                                {/* <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                    <button
                                                        className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${
                                                            option.correct ? 'bg-blue-500' : 'bg-[#fafafa]'
                                                        }`}
                                                        onClick={handleSelectMCAnswer(item, index, option, optionIndex)}
                                                    ></button>
                                                </div> */}
                                                <input 
                                                    className='flex-1 bg-[#F0F0F0] rounded-[7px] px-[12px] py-[4px]'
                                                    placeholder='選擇'
                                                    value={option.text}
                                                    onChange={handleUpdateMCAnswer(item, index, option, optionIndex)}
                                                />
                                                <div onClick={handleRemoveMCOption(item,index,option,optionIndex)} className='cursor-pointer'>
                                                    <CrossIcon/>
                                                </div>
                                            </div>
                                        ))}
                                        <div className='flex flex-row'>
                                            <div
                                                onClick={handleAddOption(item, index)}
                                                className='flex flex-row items-center gap-[10px] text-[white] text-[16px] font-[700] px-[8px] py-[8px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]'
                                                style={{ border: '1px solid #1F4CC8' }}
                                            >
                                                <AddSvg />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {/*end of multiple choice question*/}

                                {/*open end question*/}
                                {['短句作答題','選擇題 + 短句作答題'].includes(props.data?.questionnaires[index]?.type) && (
                                    <div className='w-full flex flex-col p-[16px] bg-[#F8F8F8] gap-[8px] rounded-[7px]'>
                                        <div className='font-[700]'>短句作答題問題</div>
                   
                                        <MDEditor data-color-mode="light"
                                            style={{minHeight:100}}
                                            className='bg-white'
                                            value={props.data?.questionnaires?.[index]?.questionShortanswer||''}
                                            onChange={(v)=>{onEditKey(item,index,'questionShortanswer')({target:{value:v}})}}
                                        />                                  
                                    </div>
                                )}
                                {/*end of open end question*/}

                                {/*table question*/}
                                {['表格問題'].includes(props.data?.questionnaires[index]?.type) && (
                                    <div className='w-full flex flex-col p-[16px] bg-[#F8F8F8] gap-[8px] rounded-[7px]'>
                                        <div className='font-[700]'>表格問題</div>
                                        <MDEditor data-color-mode="light"
                                            style={{minHeight:100}}
                                            className='bg-white'
                                            value={props.data?.questionnaires?.[index]?.question||''}
                                            onChange={(v)=>{onEditKey(item,index,'question')({target:{value:v}})}}
                                        />

                                        <div className='font-[700]'>表格選擇答案</div>
                                        {item?.data?.options?.map((option, optionIndex) => (
                                            <div key={optionIndex} className='flex flex-row gap-[8px] items-center'>
                                                <input 
                                                    className='flex-1 bg-[#F0F0F0] rounded-[7px] px-[12px] py-[4px]'
                                                    placeholder='選擇'
                                                    value={option.text}
                                                    onChange={handleUpdateMCAnswer(item, index, option, optionIndex)}
                                                />
                                                <div onClick={handleRemoveMCOption(item,index,option,optionIndex)} className='cursor-pointer'>
                                                    <CrossIcon/>
                                                </div>
                                            </div>
                                        ))}
                                        <div className='flex flex-row'>
                                            <div
                                                onClick={handleAddOption(item, index)}
                                                className='flex flex-row items-center gap-[10px] text-[white] text-[16px] font-[700] px-[8px] py-[8px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]'
                                                style={{ border: '1px solid #1F4CC8' }}
                                            >
                                                <AddSvg />
                                            </div>
                                        </div>


                                        <div className='font-[700]'>表格問題</div>     
                                        {item?.data?.rows?.map((option, optionIndex) => (
                                            <div key={optionIndex} className='flex flex-row gap-[8px] items-center'>
                                                <input 
                                                    className='flex-1 bg-[#F0F0F0] rounded-[7px] px-[12px] py-[4px]'
                                                    placeholder='選擇'
                                                    value={option.text}
                                                    onChange={handleUpdateRow(item, index, option, optionIndex)}
                                                />
                                                <div onClick={handleRemoveRow(item,index,option,optionIndex)} className='cursor-pointer'>
                                                    <CrossIcon/>
                                                </div>
                                            </div>
                                        ))}
                                        <div className='flex flex-row'>
                                            <div
                                                onClick={handleAddRow(item, index)}
                                                className='flex flex-row items-center gap-[10px] text-[white] text-[16px] font-[700] px-[8px] py-[8px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]'
                                                style={{ border: '1px solid #1F4CC8' }}
                                            >
                                                <AddSvg />
                                            </div>
                                        </div>            
                                    </div>
                                )}
                                {/*end of table question*/}


                            </div>
                            <div className='cursor-pointer' onClick={onDelete(item, index)}>
                                <RemoveIcon />
                            </div>
                        </div>
                    ))}
                </ReactGridLayout>
                <div className='flex flex-row mt-[16px] p-[10px]'>
                    <div
                        className='flex flex-row items-center gap-[10px] text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]'
                        style={{ border: '1px solid #1F4CC8' }}
                        onClick={onAddCard}
                    >
                        <AddSvg /> 添加問題
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Component 





const DragIcon = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={17}
      fill="none"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          fill="#000"
          d="M2 12.311h12v-1.333H2v1.333Zm0-3.333h12V7.644H2v1.334ZM2 4.31v1.333h12V4.311H2Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 .311h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  )

  const RemoveIcon = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={21}
      fill="none"
      {...props}
    >
      <path
        fill="#212121"
        d="M1.364 18.15a2.238 2.238 0 0 0 2.231 2.231h8.926a2.238 2.238 0 0 0 2.232-2.231V4.76H1.363v13.39ZM3.595 6.992h8.926V18.15H3.595V6.992Zm8.368-5.578L10.848.298h-5.58L4.154 1.414H.248v2.231h15.62V1.414h-3.905Z"
      />
    </svg>
  )

  function CrossIcon(props) {
    return (
      <svg
        width={21}
        height={21}
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <circle
          cx={10.1461}
          cy={10.1461}
          r={9.89242}
          fill="#F9FAFB"
          stroke="#111827"
          strokeWidth={0.507303}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.689 13.51a.64.64 0 11-.906-.906l2.458-2.458-2.458-2.458a.64.64 0 11.906-.906l2.458 2.458 2.458-2.458a.64.64 0 01.905.906l-2.458 2.458 2.458 2.458a.64.64 0 01-.905.905l-2.458-2.458-2.458 2.458z"
          fill="#111827"
        />
      </svg>
    )
  }